module.exports = __webpack_public_path__ + "media/schliecker-fleisch-wursttresen.91b138bf.wav";